export function invertIntervals(intervals = [], endTime) {
    const result = [];

    if (intervals.length === 0) {
        return [[0, endTime]];
    }

    let currentInterval = [];
    if (intervals[0][0] !== 0) {
        currentInterval = [0, intervals[0][0]];
        result.push(currentInterval);
        currentInterval = [];
    }

    let i = 0;
    while (i < intervals.length - 1) {
        currentInterval = [intervals[i][1], intervals[i + 1][0]];
        result.push(currentInterval);
        currentInterval = [];

        i += 1;
    }

    if (intervals[i][1] !== endTime) {
        result.push([intervals[i][1], endTime]);
    }

    return result;
}

export function intersectionOfIntervals(A, B) {
    const intersections = [];

    let i = 0;
    let j = 0;

    while (i < A.length && j < B.length) {
        const [x1, y1] = A[i];
        const [x2, y2] = B[j];

        const start = Math.max(x1, x2);
        const end = Math.min(y1, y2);
        if (start <= end) {
            intersections.push([start, end]);
        }

        if (x1 > y2) {
            j += 1;
        } else if (x2 > y1) {
            i += 1;
        } else if (y1 < y2) {
            i += 1;
        } else {
            j += 1;
        }
    }

    return intersections;
}

export function removeOverlappingIntervals(intervals) {
    if (intervals.length === 0) {
        return intervals;
    }

    let result = [intervals[0]];

    for (let i = 1; i < intervals.length; i++) {
        let currentInterval = intervals[i];
        let previousInterval = result[result.length - 1];

        if (currentInterval[0] < previousInterval[1]) {
            previousInterval[1] = Math.max(previousInterval[1], currentInterval[1]);
        } else {
            result.push(currentInterval);
        }
    }

    return result;
}

export function joinIntervals(array1, array2) {
    let result = [];
    let i = 0;
    let j = 0;

    while (i < array1.length && j < array2.length) {
        let a = array1[i];
        let b = array2[j];

        if (a[0] < b[0]) {
            result.push(a);
            i++;
        } else {
            result.push(b);
            j++;
        }
    }

    while (i < array1.length) {
        result.push(array1[i]);
        i++;
    }

    while (j < array2.length) {
        result.push(array2[j]);
        j++;
    }

    return result;
}
